export default __webpack_public_path__ + "static/media/decline_press_end.5a628c83.svg";